import { render, staticRenderFns } from "./ActionButtonDelete.vue?vue&type=template&id=436722bd&scoped=true&"
import script from "./ActionButtonDelete.vue?vue&type=script&lang=js&"
export * from "./ActionButtonDelete.vue?vue&type=script&lang=js&"
import style0 from "./ActionButton.scss?vue&type=style&index=0&id=436722bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436722bd",
  null
  
)

export default component.exports